import React from 'react';

import Slider, { SliderProps } from '@material-ui/core/Slider';

const SesamSlider: React.FC<SliderProps> = (props) => {
  return <Slider {...props} />;
};

export default SesamSlider;
